import React from 'react';
import { Box, BoxProps } from '@dripcapital/dripui-v1';
import { DAJ_COLORS } from 'utils';

type Props = Pick<BoxProps, '_sx'> & {
  children: React.ReactNode;
  dataTestId?: string;
};

const BorderCardContainer: React.FC<Props> = ({
  children,
  dataTestId,
  _sx,
}: Props) => {
  return (
    <Box
      dataTestId={dataTestId}
      _sx={{
        borderColor: DAJ_COLORS.SKY_BLUE_400,
        borderWidth: 1,
        borderStyle: 'solid',
        paddingX: 1.5,
        paddingY: 1.25,
        borderRadius: 2,
        ..._sx,
      }}
    >
      {children}
    </Box>
  );
};

export default BorderCardContainer;
